import {Injectable} from "@angular/core";
import {NestApiProvider} from "../../nest-api";
import {Observable} from "rxjs";
import {
  RequestCheckCancelAvailabilityDto,
  RequestAddSaveDto,
  RequestDeleteDraftDto,
  RequestCancelDto,
  RequestApproveDto,
  RequestGetRequestDetailDto,
} from "../dto/overtime-cancel-request.dto";

@Injectable()
export class OvertimeCancelRequestApi {
  private readonly service: string = '';
  private readonly model: string = 'overtimeCancelRequest';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public checkCancelAvailability(payload: RequestCheckCancelAvailabilityDto): Observable<any> {

    const method: string = 'POST';
    const func: string = 'checkCancelAvailability';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public add(payload: RequestAddSaveDto): Observable<any> {

    const method: string = 'POST';
    const func: string = 'add';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public saveDraft(payload: RequestAddSaveDto): Observable<any> {

    const method: string = 'POST';
    const func: string = 'saveDraft';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public deleteDraft(payload: RequestDeleteDraftDto): Observable<any> {

    const method: string = 'POST';
    const func: string = 'deleteDraft';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public cancel(payload: RequestCancelDto): Observable<any> {

    const method: string = 'POST';
    const func: string = 'cancel';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public approve(payload: RequestApproveDto): Observable<any> {

    const method: string = 'POST';
    const func: string = 'approve';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  public getRequestDetail(payload: RequestGetRequestDetailDto): Observable<any> {

    const method: string = 'POST';
    const func: string = 'getRequestDetail';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/overtime-cancel-request.api.ts